import { CommonModule } from '@angular/common'
import {
    Component,
    input,
    computed,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { injectCurrentUser, injectIsMobile } from '@mattrika/benefit-core'
import { HeaderClientDashboardComponent } from '../../headers/header-client-dashboard/header-client-dashboard.component'
import { NavigationGroup } from '../../sidebars/sidebar-admin-default/sidebar.model'
import { SidebarClientComponent } from '../../sidebars/sidebar-client/sidebar-client.component'
import {
    clientAdminNavigationGroups,
    clientMemberNavigationGroups,
    clientNavigationGroups,
} from '../../sidebars/sidebar-client/sidebar-client.data'

@Component({
    selector: 'app-layout-client-dashboard',
    imports: [
        CommonModule,
        SidebarClientComponent,
        HeaderClientDashboardComponent,
    ],
    templateUrl: './layout-client-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-client-dashboard.component.css',
})
export class LayoutClientDashboardComponent {
    logoSrc = input('assets/images/cjc.svg')
    logoAlt = input('CJC Logo')
    companyName = input('Client Workspace')
    userName = input('')
    userRole = input('')
    navigationGroups = input<NavigationGroup[]>(clientNavigationGroups)

    readonly user = injectCurrentUser()
    private readonly isMobile = injectIsMobile()

    readonly effectiveCompanyName = computed(
        () =>
            this.companyName() || this.user.companyName() || 'Client Workspace',
    )

    readonly computedNavigationGroups = computed<NavigationGroup[]>(() => {
        if (this.navigationGroups() !== clientNavigationGroups) {
            return this.navigationGroups()
        }
        return this.user.isOwner()
            ? clientAdminNavigationGroups
            : clientMemberNavigationGroups
    })

    isSidebarCollapsed = signal(false)
    isMobileSidebarOpen = signal(false)

    toggleSidebar() {
        if (this.isMobile()) {
            this.isMobileSidebarOpen.update((v) => !v)
        } else {
            this.isSidebarCollapsed.update((v) => !v)
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen.set(false)
    }
}
